import { isBusiness250Plan } from '@/shared/lib/billing/isBusiness250Plan';
import { isSubscriptionActive } from '@/shared/lib/billing/isSubscriptionActive';
import { PlanCategory, Products } from '@/shared/types/Billing';
import { User } from '@/shared/types/User';

type PricingUser = Pick<User, 'subscription'>;

export const getAvailableProducts = (products: Products | undefined, user: PricingUser | undefined) => {
  if (!products) return products;

  const experiment = products.pricing_experiment;
  const subscription = user?.subscription;
  const hasFreeSubscription = subscription?.id.startsWith('free_sub_') || subscription?.id.startsWith('sub_free_');
  const hasActiveSubscription = subscription && !hasFreeSubscription && isSubscriptionActive(subscription);
  const isBusiness250Available =
    user &&
    experiment?.eligible &&
    (experiment.variant === 'C' || experiment.variant === 'D') &&
    (experiment.offer_available ?? !hasActiveSubscription);

  return {
    ...products,
    plan: products.plan.filter(
      (plan) =>
        (plan.category === PlanCategory.Enterprise ||
          plan.category === PlanCategory.Starter ||
          Number(plan.metadata.bundle_value) > 0) &&
        (isBusiness250Available || !isBusiness250Plan(plan)),
    ),
  };
};
